import React, { Fragment, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import FlashMessage from './FlashMessage';
import { addFlashMessage, flashMessageAdd, removeFlashMessage } from '../Actions/FlashMessages.action';
import { generalErrorRemove } from '../Actions/Error.action';

const FlashMessagesContainer = () => {
    return (
        <Fragment>
            <GeneralErrorFlashMessageList />
            <FlashMessageList />
        </Fragment>
    )
}

const GeneralErrorFlashMessageList = () => {
    const dispatch = useDispatch();
    const { errors: generalErrors } = useSelector((state) => state.generalErrors);
    return (
        <Fragment>
            {generalErrors?.length > 0 && 
                generalErrors.map(error => 
                    (<FlashMessage
                        key={error.messageId}
                        {...error}
                        onDelete={() => dispatch(generalErrorRemove(error.messageId))}
                    />))
            }
        </Fragment>
    )
}

const FlashMessageList = () => {
    const dispatch = useDispatch();
    const flashMessages = useSelector((state) => state.flashMessages);
    return (
        <Fragment>
            {flashMessages.length > 0 && 
                flashMessages.map((message) => 
                    (<FlashMessage 
                        key={message.messageId}
                        {...message}
                        onDelete={({ closedByUser }) => dispatch(removeFlashMessage(message, closedByUser))}
                    />))
            }
        </Fragment>
    )
}

export default FlashMessagesContainer;